export const PolicyPath = {
    // 신규 회원 가입 시 약관
    SERVICE: '/pdf/pdf_service_policy.pdf',
    PRIVACY: '/pdf/pdf_privacy_policy2.pdf', // "개인정보처리지침"
};
